define('commons/publish',['jquery', 'commons/message-manager'], function($, messages) {
    var publishCallback = function(event) {
        var checkbox = $(event.currentTarget);
        var published = checkbox.data('published');
        if (confirm('Are you sure you want to ' + (published ? 'publish' : 'unpublish') + ' this post ?')) {
            $.ajax({
                type: 'POST',
                url: checkbox.attr('href') + published,
                success: function(data) {
                    if (data.success) {
                        checkbox.data('published', !published);
                        checkbox.attr('title', published ? 'Unpublish' : 'Publish');
                        // refresh checkbox
                        if (!published) {
                            checkbox.addClass('icon-check-empty');
                            checkbox.removeClass('icon-check');
                            messages.info("The post has been unpublished");
                        } else {
                            checkbox.addClass('icon-check');
                            checkbox.removeClass('icon-check-empty');
                            messages.info("The post has been published");
                        }
                    } else {
                        messages.error('An unexpected error occurred.');
                    }
                }
            });
        }
        return false;
    };

    return function(publishSelector) {
        $(publishSelector).click(publishCallback);
    };
});
